module.exports = "<div style=\"width: 100%;\" [ngStyle]=\"{'background-color': getTrackingInfo().color}\" class=\" bold\">\r\n  <i [ngClass]=\"getTrackingInfo().icon\" aria-hidden=\"true\"></i>\r\n  {{ getTrackingInfo().label}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/formWidgets/EntityStatus.component.html
// module id = ../../../../../src/app/helpers/components/formWidgets/EntityStatus.component.html
// module chunks = main